export default __webpack_public_path__ + "locales/tr/InviteDialog.json?hash=7bdf43710650e18f0566d6e837be85c7";